module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("OUR JOURNEY")]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/p5"
    }
  }, [_c('b', [_vm._v("PREFACE ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/p6"
    }
  }, [_vm._v("1. "), _c('b', [_vm._v("REWILDING ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('b', [_vm._v("LAKOTA LANDS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('b', [_vm._v("RESCUE ME ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. "), _c('b', [_vm._v("LUCY ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. "), _c('b', [_vm._v("HOOVES ON FIRST ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. "), _c('b', [_vm._v("GIN RUMMY AND LEMON MOISTURIZER ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('b', [_vm._v("AWAKENINGS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. "), _c('b', [_vm._v("MOSES BRINGS PLENTY ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. "), _c('b', [_vm._v("IT TAKES A VILLAGE—OR A CONGRESSMAN ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. "), _c('b', [_vm._v("MORNING JOE ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. "), _c('b', [_vm._v("CAMBRIDGE ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. "), _c('b', [_vm._v("SERENDIPITY ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. "), _c('b', [_vm._v("BORN TO REWILD ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/p19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. "), _c('b', [_vm._v("WHAT NOW? ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35519822","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/p4.vue
// module id = 66
// module chunks = 0